import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import AdminLayout from "../pages/admin/AdminLayout";
import { ROLES } from "../core/constants";
import { SystemEnvProvider } from "../pages/admin/SystemEnvContext";

export default function AdminRoutes() {
    const { auth, isAuthenticated } = useAuth();
    const location = useLocation();

    const checkRole = () => {
        return auth.admin_level_cd === ROLES.Admin || auth.admin_level_cd === ROLES.Volunteer;
    };

    return checkRole() ? (
        <SystemEnvProvider>
            <AdminLayout>
                <Outlet />
            </AdminLayout>
        </SystemEnvProvider>
    ) : isAuthenticated ? (
        <Navigate to={"/unauthorized"} state={{ from: location }} replace />
    ) : (
        <Navigate to={"/"} state={{ from: location }} replace />
    );
}
